import Icon from '../components/Icon.vue'

Icon.register({
  'mouse-pointer': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M302.2 329.1h-106.1l55.8 136c3.9 9.4-0.6 20-9.4 24l-49.2 21.4c-9.2 4-19.4-0.6-23.3-9.7l-53.1-129.1-86.7 89.1c-11.5 11.9-30.3 2.7-30.3-12.9v-429.7c0-16.4 19.9-24.4 30.3-12.9l284.4 292.5c11.5 11.2 3 31.1-12.5 31.1z'
      }
    ]
  }
})
